import { useScreen } from '../useScreen';

interface ViewProps {
    onContinue: () => void;
}

const useDropOffConfirmed = (): ViewProps => {
    const { onContinue, onHome, continueEnabled } = useScreen();

    return {
        onContinue: continueEnabled ? onContinue : onHome
    };
};

export default useDropOffConfirmed;
